import { Store } from '@ngxs/store';
import * as i0 from "@angular/core";
import * as i1 from "@ngxs/store";
export var ConsoleStateActions;
(function (ConsoleStateActions) {
  let SetCurrentView = /*#__PURE__*/(() => {
    class SetCurrentView {
      static {
        this.type = '[ConsoleState] SetCurrentView';
      }
      constructor(view) {
        this.view = view;
      }
    }
    return SetCurrentView;
  })();
  ConsoleStateActions.SetCurrentView = SetCurrentView;
  let SetViewState = /*#__PURE__*/(() => {
    class SetViewState {
      static {
        this.type = '[ConsoleState] SetViewState';
      }
      constructor(viewId, data) {
        this.viewId = viewId;
        this.data = data;
      }
    }
    return SetViewState;
  })();
  ConsoleStateActions.SetViewState = SetViewState;
  let RestorePersistedState = /*#__PURE__*/(() => {
    class RestorePersistedState {
      static {
        this.type = '[ConsoleState] RestorePersistedState';
      }
      constructor() {}
    }
    return RestorePersistedState;
  })();
  ConsoleStateActions.RestorePersistedState = RestorePersistedState;
})(ConsoleStateActions || (ConsoleStateActions = {}));
export let ConsoleFacade = /*#__PURE__*/(() => {
  class ConsoleFacade {
    constructor(store) {
      this.store = store;
    }
    setCurrentView(viewIndex) {
      this.store.dispatch(new ConsoleStateActions.SetCurrentView(viewIndex));
    }
    setViewState(viewId, data) {
      this.store.dispatch(new ConsoleStateActions.SetViewState(viewId, data));
    }
    static {
      this.ɵfac = function ConsoleFacade_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ConsoleFacade)(i0.ɵɵinject(i1.Store));
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: ConsoleFacade,
        factory: ConsoleFacade.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return ConsoleFacade;
})();